<template>
  <div class="special-list">
    <Special
      v-for="special in specials"
      :key="special.id"
      :special-id="special.id"
      :image-url="special.imageUrl"
    />
  </div>
</template>
<script>
import Special from './Special.vue'
export default {
  components: { Special },
  props: {
    specials: {
      type: Array,
      required: true
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.$emit('mount')
    })
  }
}
</script>
<style lang="scss" scoped>
.special-list {
  @extend %custom-scrollbar;
  display: flex;
  overflow: visible;
}
</style>
